import { render, staticRenderFns } from "./sandbox-menu-item.vue?vue&type=template&id=6952b4cd&"
import script from "./sandbox-menu-item.vue?vue&type=script&lang=js&"
export * from "./sandbox-menu-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports